<template>
<div class="cavani_tm_section" id="parceiros">
  <div class="section_inner">
    <div class="cavani_tm_about">
      <div class="partners">
        <div class="cavani_tm_title">
          <span>Parceiros</span>
        </div>
        <div class="list">
          <ul>
            <li>
              <div class="list_inner">
                <img :src="'site/images/parceiros/cnpq.png'" alt="">
                <a class="cavani_tm_full_link" href="//www.gov.br/cnpq/pt-br" target="_blank"></a>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <img :src="'site/images/parceiros/sbem.png'" alt="">
                <a class="cavani_tm_full_link" href="http://www.sbembrasil.org.br/sbembrasil/" target="_blank"></a>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <img :src="'site/images/parceiros/caceres.svg'" alt="">
                <a class="cavani_tm_full_link" href="https://www.caceres.mt.gov.br/" target="_blank"></a>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <img :src="'site/images/parceiros/grupo_cometa.png'" alt="">
                <a class="cavani_tm_full_link" href="https://www.viacometa.com.br/" target="_blank"></a>
              </div>
            </li>
<!--            <li>-->
<!--              <div class="list_inner">-->
<!--                <img :src="'site/images/parceiros/instituto_cometa.png'" alt="">-->
<!--                <a class="cavani_tm_full_link" href="https://www.institutocometa.org.br/" target="_blank"></a>-->
<!--              </div>-->
<!--            </li>-->
            <li>
              <div class="list_inner">
                <img :src="'site/images/parceiros/logo_seeg.jpg'" alt="">
                <a class="cavani_tm_full_link" href="//seegfibras.com.br/" target="_blank"></a>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <img :src="'site/images/parceiros/juba.png?v=1.1'" alt="">
                <a class="cavani_tm_full_link" href="//juba.com.br" target="_blank"></a>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <img :src="'site/images/parceiros/aguas_do_pantanal.png'" alt="">
                <a class="cavani_tm_full_link" href="//aguasdopantanal.eco.br" target="_blank"></a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {

}
</script>
